
import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import StorageService from "utils/StorageServices/StorageServices";
import BootstrapTable from 'components/BootstrapTable';
import LoadingBar from 'react-top-loading-bar';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { addBalanceApi, getWalletTransactionList } from '_services/walletService/walletService';
import { utils } from 'helper';
import { LuWallet } from 'react-icons/lu';
import { AddBalanceContinueModal, AddBalanceModal } from 'modals';
import toast from 'react-hot-toast';
import { load } from '@cashfreepayments/cashfree-js';
import logo from "../../assets/img/transport360Logo.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import { paymentVerifyApi } from '_services';

const WalletTransacrtion = ({ showOffcanvas, listSearch }) => {
  useDocumentTitle("Wallet | T360");
  const CASHFREE_MODE = process.env.REACT_APP_CASHFREE_MODE;
  const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;
  const API_URL = process.env.REACT_APP_API_URL;
  const STAGING_API_URL = process.env.REACT_APP_STAGING_API_URL;
  const LIVE_API_URL = process.env.REACT_APP_LIVE_API_URL;
  const loadingBarRef = useRef(null);
  const { userData } = useContext(UserContext);
  const [transactionList, setTransactionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAddBalance, setOpenAddBalance] = useState(false);
  const [openAddBalanceContinue, setOpenAddBalanceContinue] = useState(false);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,

  });

  const location = useLocation();
  const navigate = useNavigate();


  const [form, setForm] = useState({
    amount: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const firstKey = Array.from(urlParams.keys())[0];

    if (firstKey && firstKey.startsWith("order_")) {
      addBanaceVerifyHandle(firstKey);
    } else {
      return;
    }
  }, [location.search]);

  const addBanaceVerifyHandle = async (orderId) => {
    const payload = {
      order_id: orderId,
      company_id: StorageServices.getCompanyId(),
    };

    try {

      let res;

      res = await paymentVerifyApi(payload);

      if (res?.responseCode === 200) {
        const { status, return_url } = res.data;

        if (status === 1) {
          toast.success("Payment completed successfully!");
          navigate("/wallet");
        } else if (status === 0) {
          navigate("/wallet");
          toast.error("Payment is still pending. Please wait or contact support.");
        } else {
          navigate("/wallet");
          // Payment failed
          toast.error("Payment failed. Please try again or contact support.");

        }
      } else {

        toast.error("Unable to verify payment. Please contact support.");
      }
    } catch (error) {
      console.error("Payment verification error:", error);
      toast.error("Unable to verify payment status. Please contact support if amount was debited.");

    } finally {
      // setVerifyLoading(false);
    }
  }

  const getDataOwnDriverList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getWalletTransactionList(object);
      if (res?.responseCode == 200) {
        setTransactionList(res?.data)

      }
    } catch (error) {
      // throw error;
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    getDataOwnDriverList();
  }, [listSearch, filter, showOffcanvas])


  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Date", accessor: "dateTran" },
    { header: "Transaction Type", accessor: "type" },
    { header: "Description", accessor: "descriptions" },
    { header: "User", accessor: "user" },
    { header: "Receipt (₹)", accessor: "credit" },
    { header: "Payment (₹)", accessor: "debit" },
    { header: "Running Balance (₹)", accessor: "amount" }

  ];

  const RowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,

      dateTran: <div className="_dateNtime _pDate">
        <p className="_tblText_inDent">
          {item?.createdAt
            ? utils.formatDateMonth(item?.createdAt)
            : ""} | {item?.createdAt
              ? utils.formatTime(item?.createdAt)
              : ""}
        </p>

      </div>,
      user: <>{item?.created_by?.full_name}</>,
      descriptions: <>{item?.description || "-"}</>,
      type: item?.type || "-",
      amount: `₹ ${(userData?.balance_amount ? userData?.balance_amount : 0).toFixed(2)}`

    }));
  };

  const handleAddBalance = () => {
    setOpenAddBalanceContinue(true);
  }

  const submitAddBalanceContinue = () => {
    setOpenAddBalanceContinue(false);
    setOpenAddBalance(true);

  }

  const submitAddBalance = async () => {
    setLoading(true)
    const payload = {
      balance: form.totalAmount,
      company_id: StorageService.getCompanyId(),
      // return_url: "http://localhost:3000/wallet",
      return_url:
        CASHFREE_MODE === "sandbox"
          ? (TRANSPORT_MODE === "staging" ? STAGING_API_URL : API_URL) + "/wallet"
          : (TRANSPORT_MODE === "staging" ? STAGING_API_URL : LIVE_API_URL) + "/wallet",
      name: form?.name,
      gst_number: form?.isCheck ? form?.gst_number : "",
      state: form?.state?.name
    }
    try {
      const res = await addBalanceApi(payload);

      if (res?.responseCode == 200) {

        const { order_id, payment_session_id } = res.data;

        if (!payment_session_id) {
          toast.error("Failed to create payment session");
          return;
        }
        setOpenAddBalance(false);
        await initializeCashfreePayment(payment_session_id, order_id);
      }
    } catch (error) {
      console.error("Error adding balance:", error);
    } finally {
      setLoading(false)
    }
  }

  const initializeCashfreePayment = useCallback(async (paymentSessionId, orderId) => {
    try {
      const cashfree = await load({ mode: CASHFREE_MODE });

      const checkoutOptions = {
        paymentSessionId,
        redirectTarget: "_self",
        appearance: {
          width: "500px",
          height: "650px",
          primaryColor: "#3B82F6",
          backgroundColor: "#FFFFFF",
          theme: {
            primaryColor: "#3B82F6",
            secondaryColor: "#F3F4F6",
            backgroundColor: "#FFFFFF",
            textColor: "#1F2937",
            borderColor: "#E5E7EB",
            errorColor: "#EF4444",
            successColor: "#10B981"
          }
        },
        modal: {
          closeOnOverlayClick: false,
          closeOnEsc: false
        },
        merchant: {
          name: "Transport 360",
          logo: logo,
        }
      };

      const result = await cashfree.checkout(checkoutOptions);
    } catch (error) {
      console.error("Cashfree SDK error:", error);
      toast.error("Payment system error. Please try again.");
    }
  }, []);

  const addBaalanceContinueProps = {

    isOpen: openAddBalanceContinue,
    closeModal: () => setOpenAddBalanceContinue(false),
    modalMainClass: "_dashCommon_Modal _smModal addbalance",
    modalTitle: "Add Balance",
    submitTitle: "Continue",
    setForm: setForm,
    form: form,
    onSubmit: submitAddBalanceContinue,
  };

  const addBaalanceProps = {

    isOpen: openAddBalance,
    closeModal: () => {
      setForm({
        amount: 0,
        totalAmount: 0
      });
      setOpenAddBalance(false)
    },
    modalMainClass: "_dashCommon_Modal _smModal addbalance",
    modalTitle: "Add Balance",
    submitTitle: "Add Balance",
    setForm: setForm,
    form: form,
    onSubmit: submitAddBalance,
    isLoadding: loading
  };

  return (
    <>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <div className='_tabWith_topTab'>
        <div className='__availBal_bxs'>
          <div className='__availBal_bxs_innr'>
            <div className='__availBal_inrBx'>
              <span className='__avlWallet'><LuWallet /></span>
              <div className='__avlDetail'>
                <p>Available Balance</p>
                <h2>{`₹ ${(userData?.balance_amount ? userData?.balance_amount : 0).toFixed(2)}`}</h2>
              </div>

              <button className='__addBal_btn' onClick={handleAddBalance}><LuWallet /> <span>Add Balance</span></button>
            </div>
          </div>
        </div>
        <BootstrapTable
          columns={columns}
          data={RowListData(transactionList?.length > 0 ? transactionList : [])}
          isLoading={loading}
        />

        {openAddBalanceContinue && (
          <AddBalanceContinueModal {...addBaalanceContinueProps} />
        )}
        {openAddBalance && (
          <AddBalanceModal {...addBaalanceProps} />
        )}
      </div>

    </>
  );
}

export default WalletTransacrtion;
